import { useRouter } from 'next/navigation';
import useQueryString from '~/hooks/useQueryString';

export default function useScanHistoryFilter() {
  const router = useRouter();
  const { searchParams, pathname, updateSearchParams } = useQueryString();

  const brandIds = searchParams?.get('brandIds')?.split(',') || [];
  const [orderByKey, orderByValue] = searchParams?.get('reportsSort')?.split('_') || [];

  const onFilterChange = (key: 'brandIds', value: string[]) => {
    updateSearchParams(key, value.length ? value.join(',') : null);
  };

  const clearFilter = () => {
    const newSearchParams = new URLSearchParams(searchParams?.toString() || undefined);
    newSearchParams.delete('brandIds');
    router.push(`${pathname}?${newSearchParams.toString()}`);
  };

  const onSort = (key: string, value: 'ASC' | 'DESC' | null) => {
    updateSearchParams('reportsSort', value ? `${key}_${value}` : null);
  };

  return {
    brandIds,
    onFilterChange,
    clearFilter,
    onSort,
    orderBy: orderByKey
      ? {
          key: orderByKey,
          order: orderByValue as 'ASC' | 'DESC',
        }
      : { key: 'lastScanAt', order: 'DESC' as const },
  };
}
